"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rectangle = exports.useTramlineContext = exports.TramlineSequence = exports.TramlineContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = __importDefault(require("@mui/material/Box"));
const green = "#44E1BC";
const blue = "#2F74F980";
const colors = [green, blue];
function newLayout(params) {
    return {
        top: Object.assign({ top: "-24px", height: "100px" }, params === null || params === void 0 ? void 0 : params.top),
        bottom: Object.assign({ bottom: "-24px", height: "100px" }, params === null || params === void 0 ? void 0 : params.bottom),
    };
}
const layouts = [
    // Vertical
    newLayout({
        top: { width: "80%", left: "15%" },
        bottom: { width: "30%", left: "5%" },
    }),
    newLayout({
        top: { width: "40%", left: "10%" },
        bottom: { width: "80%", left: "15%" },
    }),
    // Diagonal
    newLayout({
        top: { width: "60%", height: "120px", left: "-24px" },
        bottom: { width: "50%", height: "160px", left: "calc(50% + 24px)" },
    }),
    newLayout({
        top: { width: "40%", height: "100px", left: "calc(60% + 24px)" },
        bottom: { height: "200px", width: "50%", left: "-24px" },
    }),
    // Horizontal
    newLayout({
        top: { top: "20%", height: "75%", left: "-24px", width: "48px" },
        bottom: {
            bottom: "30%",
            height: "60%",
            left: "calc(100% - 24px)",
            width: "48px",
        },
    }),
    newLayout({
        top: { top: "20%", height: "60%", left: "-24px", width: "48px" },
        bottom: {
            bottom: "10%",
            height: "80%",
            left: "calc(100% - 120px + 24px)",
            width: "120px",
        },
    }),
];
exports.TramlineContext = (0, react_1.createContext)(null);
function randomLayout() {
    let nextLayout;
    do {
        nextLayout = layouts[Math.floor(Math.random() * layouts.length)];
    } while (nextLayout == randomLayout.last);
    randomLayout.last = nextLayout;
    return randomLayout.last;
}
randomLayout.last = null;
function randomColors() {
    return Math.random() >= 0.5 ? colors : [colors[1], colors[0]];
}
// Provides a stable selection of tramline layout & color selection for each "view".
// Intended for multi-step dialogs (e.g. the connection create flow), to maintain
// a stable appearance while the user is within the flow.
function TramlineSequence({ view, children, }) {
    const colors = (0, react_1.useMemo)(() => randomColors(), []);
    const startLayout = (0, react_1.useMemo)(() => randomLayout(), []);
    // Store generated layouts in a map, starting with the first step
    const sequenceRef = (0, react_1.useRef)({
        [view]: {
            layout: startLayout,
            colors,
        },
    });
    // Generate a new layout if this is the first time we've seen this step
    if (!sequenceRef.current[view]) {
        sequenceRef.current[view] = {
            layout: randomLayout(),
            colors: randomColors(),
        };
    }
    return ((0, jsx_runtime_1.jsx)(exports.TramlineContext.Provider, Object.assign({ value: sequenceRef.current[view] }, { children: children })));
}
exports.TramlineSequence = TramlineSequence;
function useTramlineContext() {
    const ctx = (0, react_1.useContext)(exports.TramlineContext);
    // If there is nothing provided by a parent,
    // we return a randomly selected - but stable -
    // layout and color palette.
    const defaultCtx = (0, react_1.useMemo)(() => ({
        layout: randomLayout(),
        colors: randomColors(),
    }), []);
    return ctx || defaultCtx;
}
exports.useTramlineContext = useTramlineContext;
function Rectangle(props) {
    const { borderWidth = "4px", borderColor, style } = props;
    return ((0, jsx_runtime_1.jsx)("div", { style: Object.assign({ width: `calc(100% - 2 * ${borderWidth})`, height: `calc(100% - 2 * ${borderWidth})`, borderColor: borderColor, borderStyle: "solid", borderWidth: 4, borderRadius: 10, opacity: 0.5 }, style) }));
}
exports.Rectangle = Rectangle;
function Tramlines({ children }) {
    const { layout, colors } = useTramlineContext();
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { position: "relative", marginY: "4ch" } }, { children: [(0, jsx_runtime_1.jsx)(Rectangle, { style: {
                    position: "absolute",
                    height: layout.top.height,
                    width: layout.top.width,
                    left: layout.top.left,
                    top: layout.top.top,
                }, borderColor: colors[0] }), (0, jsx_runtime_1.jsx)(Rectangle, { style: {
                    position: "absolute",
                    height: layout.bottom.height,
                    width: layout.bottom.width,
                    left: layout.bottom.left,
                    bottom: layout.bottom.bottom,
                }, borderColor: colors[1] }), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { position: "relative" } }, { children: children }))] })));
}
exports.default = Tramlines;
